import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import ProtectedRoute from "./ProtectedRoute";

// páginas públicas
import Home from "../../pages/public/Home";
import Login from "../../pages/public/Login";
import Register from "../../pages/public/Register";
import ResetPassword from "../../pages/public/ResetPassword";

// layout oficial da v4
import AppLoggedPageLayout from "../layout/AppLoggedPageLayout";

// núcleo principal logado
import AppHome from "../../pages/app/AppHome";
import Profile from "../../pages/app/Profile";
import Medications from "../../pages/app/Medications";
import Routine from "../../pages/app/Routine";
import Readings from "../../pages/app/Readings";
import Evolution from "../../pages/app/Evolution";
import Settings from "../../pages/app/Settings";

// complementares mantidos
import Diary from "../../pages/app/Diary";
import MariaBot from "../../pages/app/MariaBot";
import Mystika from "../../pages/app/Mystika";

// páginas dedicadas de readings V5
import HydrationPage from "../../pages/app/readings/HydrationPage";
import WeightPage from "../../pages/app/readings/WeightPage";
import BloodPressurePage from "../../pages/app/readings/BloodPressurePage";
import GlucosePage from "../../pages/app/readings/GlucosePage";
import BodyCompositionPage from "../../pages/app/readings/BodyCompositionPage";
import BodyMeasurementsPage from "../../pages/app/readings/BodyMeasurementsPage";

// legado temporário
import Dashboard from "../../pages/app/Dashboard";

export default function AppRoutes() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        {/* públicas */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* protegidas */}
        <Route element={<ProtectedRoute />}>
          {/* entrada padrão */}
          <Route path="/app" element={<Navigate to="/app/home" replace />} />

          {/* HOME */}
          <Route
            path="/app/home"
            element={
              <AppLoggedPageLayout
                hideTopSection={true}
              >
                <AppHome />
              </AppLoggedPageLayout>
            }
          />

          {/* PROFILE */}
          <Route
            path="/app/profile"
            element={
              <AppLoggedPageLayout
                title="Seu perfil"
                subtitle="Atualize suas informações"
              >
                <Profile />
              </AppLoggedPageLayout>
            }
          />

          {/* MEDICATIONS */}
          <Route
            path="/app/medications"
            element={
              <AppLoggedPageLayout
                title="Medicações"
                subtitle="Organize seus medicamentos e estoque"
              >
                <Medications />
              </AppLoggedPageLayout>
            }
          />

          {/* ROUTINE */}
          <Route
            path="/app/routine"
            element={
              <AppLoggedPageLayout
                title="Rotina"
                subtitle="Acompanhe seu uso diário"
              >
                <Routine />
              </AppLoggedPageLayout>
            }
          />

          {/* READINGS */}
          <Route
            path="/app/readings"
            element={
              <AppLoggedPageLayout
                title="Registros"
                subtitle="Acompanhe sua evolução"
              >
                <Readings />
              </AppLoggedPageLayout>
            }
          />

          {/* EVOLUTION */}
          <Route
            path="/app/evolution"
            element={
              <AppLoggedPageLayout
                title="Evolução"
                subtitle="Veja seu progresso ao longo do tempo"
              >
                <Evolution />
              </AppLoggedPageLayout>
            }
          />

          {/* SETTINGS */}
          <Route
            path="/app/settings"
            element={
              <AppLoggedPageLayout
                title="Configurações"
                subtitle="Ajuste sua experiência"
              >
                <Settings />
              </AppLoggedPageLayout>
            }
          />

          {/* READINGS V5 DEDICADAS */}
          <Route
            path="/app/hydration"
            element={
              <AppLoggedPageLayout title="Hidratação" subtitle="Acompanhe sua hidratação">
                <HydrationPage />
              </AppLoggedPageLayout>
            }
          />
          <Route
            path="/app/readings/weight"
            element={
              <AppLoggedPageLayout title="Peso" subtitle="Acompanhe a evolução">
                <WeightPage />
              </AppLoggedPageLayout>
            }
          />
          <Route
            path="/app/readings/blood-pressure"
            element={
              <AppLoggedPageLayout title="Pressão Arterial" subtitle="Aferições e histórico de pressão">
                <BloodPressurePage />
              </AppLoggedPageLayout>
            }
          />
          <Route
            path="/app/readings/glucose"
            element={
              <AppLoggedPageLayout title="Glicemia" subtitle="Registros e monitoramento glicêmico">
                <GlucosePage />
              </AppLoggedPageLayout>
            }
          />
          <Route
            path="/app/readings/body-composition"
            element={
              <AppLoggedPageLayout title="Composição Corporal" subtitle="Gordura corporal e massa muscular">
                <BodyCompositionPage />
              </AppLoggedPageLayout>
            }
          />
          <Route
            path="/app/readings/measures"
            element={
              <AppLoggedPageLayout title="Medidas Corporais" subtitle="Acompanhe suas circunferências">
                <BodyMeasurementsPage />
              </AppLoggedPageLayout>
            }
          />

          {/* complementares */}
          <Route
            path="/app/diary"
            element={
              <AppLoggedPageLayout title="Diário">
                <Diary />
              </AppLoggedPageLayout>
            }
          />

          <Route
            path="/app/maria-bot"
            element={
              <AppLoggedPageLayout title="Maria">
                <MariaBot />
              </AppLoggedPageLayout>
            }
          />

          <Route
            path="/app/mystika"
            element={
              <AppLoggedPageLayout title="Mystika">
                <Mystika />
              </AppLoggedPageLayout>
            }
          />

          {/* legado */}
          <Route
            path="/app/dashboard"
            element={
              <AppLoggedPageLayout title="Dashboard">
                <Dashboard />
              </AppLoggedPageLayout>
            }
          />

          {/* redirecionamentos */}
          <Route
            path="/app/flasks"
            element={<Navigate to="/app/medications" replace />}
          />
          <Route
            path="/app/doses"
            element={<Navigate to="/app/routine" replace />}
          />
          <Route
            path="/app/measurements"
            element={<Navigate to="/app/readings" replace />}
          />
        </Route>

        {/* fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}